import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import customFetch from '../utils/customFetch';
import Logo from '../components/Logo';

// Landeseite für die E-Mail-Links: ?mode=confirm (neue Adresse) bzw.
// ?mode=cancel (Abbruch aus der Benachrichtigung an die alte Adresse).
const EmailChange = () => {
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode') === 'cancel' ? 'cancel' : 'confirm';
  const token = searchParams.get('token');
  const email = searchParams.get('email');

  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const ranRef = useRef(false);

  useEffect(() => {
    // Verhindert doppelten Aufruf im React-StrictMode
    if (ranRef.current) return;
    ranRef.current = true;

    const run = async () => {
      try {
        if (mode === 'cancel') {
          if (!token) throw new Error('invalid');
          const { data } = await customFetch.post(
            '/auth/account/email-change/cancel',
            { token }
          );
          setMessage(data.msg || 'Der E-Mail-Wechsel wurde abgebrochen.');
        } else {
          if (!token || !email) throw new Error('invalid');
          const { data } = await customFetch.post(
            '/auth/account/email-change/confirm',
            { token, email }
          );
          setMessage(data.msg || 'Deine E-Mail-Adresse wurde geändert.');
        }
        setStatus('success');
      } catch (error) {
        setMessage(
          error?.response?.data?.msg ||
            'Der Link ist ungültig oder abgelaufen.'
        );
        setStatus('error');
      }
    };
    run();
  }, [mode, token, email]);

  const title =
    mode === 'cancel' ? 'E-Mail-Wechsel abbrechen' : 'Neue E-Mail bestätigen';

  return (
    <div className="h-full bg-gray-50" style={{ height: '100vh' }}>
      <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <Link to="/">
            <Logo />
          </Link>
          <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
            {title}
          </h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
          <div className="bg-white px-6 py-12 text-center shadow-sm sm:rounded-lg sm:px-12">
            {status === 'loading' ? (
              <p className="text-sm text-gray-700">Einen Moment bitte…</p>
            ) : (
              <p
                className={
                  status === 'success'
                    ? 'text-sm text-green-700'
                    : 'text-sm text-red-700'
                }
              >
                {message}
              </p>
            )}
            <Link to="/login">
              <div className="mt-6">
                <button
                  type="button"
                  className="flex w-full justify-center rounded-md bg-svisit-primary-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-xs hover:bg-svisit-primary-500"
                >
                  Zum Login
                </button>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailChange;
